@let fontSize = fontSize$ | async;
@let options = usersRepository();
@let placeholderText = placeholder();
<plugins-autocomplete
  [formControl]="searchControl"
  [options]="options"
  [color]="color()"
  (selected)="onSelect($event)"
  [autocompleteId]="'auto-' + inputId"
  [placeholder]="
    placeholderText.custom
      ? placeholderText.custom
      : (placeholderText.default | translate)
  "
  [inputId]="inputId"
  (onBlur)="handleBlur()"
>
  <ng-template [pluginsAutocompleteOption]="options" let-option>
    <div
      class="result-wrapper"
      [style.height]="lineHeightSize()"
      [style.fontSize]="fontSize"
    >
      <plugins-user-entity
        [size]="size()"
        [showTitle]="true"
        [detailedTitle]="detailedTitle()"
        [userProvider]="option"
        [profileLinkEnabled]="false"
      />
    </div>
  </ng-template>
</plugins-autocomplete>
